import React, { useState, useEffect } from 'react';

// หน้าไว้อาลัย (Memorial Splash) — แสดงก่อนเข้าเว็บ
// ตั้งค่าผ่านแอดมิน (setting key 'memorial'):
//   { enabled, imageUrl, bgColor, autoEnterSec, frequency('daily'|'always'|'once'), startAt, endAt }
const API = process.env.REACT_APP_API_URL || '/api';
const ASSET = API.replace(/\/api\/?$/, ''); // origin ของไฟล์ /uploads (prod = '')
const SEEN_KEY = 'kby_memorial_seen';

function withinSchedule(cfg) {
  const now = Date.now();
  if (cfg.startAt) { const s = new Date(cfg.startAt).getTime(); if (!isNaN(s) && now < s) return false; }
  if (cfg.endAt) { const e = new Date(cfg.endAt).getTime(); if (!isNaN(e) && now > e) return false; }
  return true;
}

function alreadySeen(freq) {
  try {
    const v = localStorage.getItem(SEEN_KEY);
    if (freq === 'always') return false;
    if (freq === 'once') return !!v;
    // daily (default): เห็นครั้งเดียวต่อวัน
    return v === new Date().toISOString().slice(0, 10);
  } catch (e) { return false; }
}
function markSeen(freq) {
  try {
    if (freq === 'always') return;
    localStorage.setItem(SEEN_KEY, freq === 'once' ? '1' : new Date().toISOString().slice(0, 10));
  } catch (e) {}
}

export default function MemorialSplash() {
  const [cfg, setCfg] = useState(null);
  const [visible, setVisible] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${API}/settings/memorial`);
        if (!res.ok) return;
        const j = await res.json();
        const c = (j && j.data && j.data.value) || null;
        if (!alive || !c || !c.enabled || !c.imageUrl) return;
        if (!withinSchedule(c)) return;
        const freq = c.frequency || 'daily';
        if (alreadySeen(freq)) return;
        setCfg(c); setVisible(true);
        // ล็อก scroll พื้นหลังระหว่างแสดง
        document.body.style.overflow = 'hidden';
        const sec = Number(c.autoEnterSec);
        if (sec && sec > 0) {
          const t = setTimeout(() => close(c), sec * 1000);
          return () => clearTimeout(t);
        }
      } catch (e) { /* เงียบ — ไม่ให้กระทบเว็บ */ }
    })();
    return () => { alive = false; };
  }, []);

  const close = (c) => {
    markSeen((c || cfg || {}).frequency || 'daily');
    setFadeOut(true);
    setTimeout(() => { setVisible(false); document.body.style.overflow = ''; }, 450);
  };

  if (!visible || !cfg) return null;
  const imgSrc = /^https?:\/\//.test(cfg.imageUrl) ? cfg.imageUrl : ASSET + cfg.imageUrl;

  return (
    <div
      onClick={() => close(cfg)}
      style={{
        position: 'fixed', inset: 0, zIndex: 2147483646,
        background: cfg.bgColor || '#000',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        opacity: fadeOut ? 0 : 1, transition: 'opacity 0.45s ease',
        cursor: 'pointer',
      }}
      role="dialog" aria-label="หน้าไว้อาลัย"
    >
      <img
        src={imgSrc}
        alt=""
        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', display: 'block', animation: 'kbyMemFade 1s ease' }}
      />
      <button
        onClick={(e) => { e.stopPropagation(); close(cfg); }}
        style={{
          position: 'fixed', bottom: '26px', left: '50%', transform: 'translateX(-50%)',
          padding: '11px 26px', borderRadius: '999px',
          background: 'rgba(255,255,255,0.12)', color: '#fff',
          border: '1px solid rgba(255,255,255,0.35)', backdropFilter: 'blur(4px)',
          fontSize: '14px', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
          letterSpacing: '0.3px',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.22)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.12)'; }}
      >
        เข้าสู่เว็บไซต์ →
      </button>
      <style>{`@keyframes kbyMemFade{from{opacity:0}to{opacity:1}}`}</style>
    </div>
  );
}
